/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const FullBleedImageCalloutSection = ({
  bgOverride,
  cta,
  description,
  footer,
  image,
  title,
}) => {
  return (
    <Box bg={bgOverride} sx={{ overflow: 'hidden' }}>
      <Container>
        <Grid
          columns={[null, 2]}
          sx={{
            alignItems: 'center',
            rowGap: 0,
            textAlign: ['center', 'left'],
            textWrap: 'pretty',
          }}
        >
          <Box py={5}>
            <Heading
              as="h2"
              variant="title2"
              mt={0}
              mb={2}
              sx={{ maxWidth: [null, '500px'] }}
            >
              {title}
            </Heading>
            {description && (
              <Box
                mb={3}
                sx={{
                  variant: 'text.body2',
                  maxWidth: ['480px', 'none'],
                  mx: 'auto',
                  p: { m: 0 },
                  a: {
                    variant: 'text.link',
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
            {cta}
            {footer && (
              <Box
                mt={2}
                sx={{
                  variant: 'text.subtitle2',
                  p: { m: 0 },
                }}
                dangerouslySetInnerHTML={{
                  __html: footer.childMarkdownRemark.html,
                }}
              />
            )}
          </Box>
          <Box
            ml={[-2, 0]}
            mr={[-2, -3, -10, -3]}
            sx={{
              height: '100%',
              '@media only screen and (min-width: 1170px)': {
                height: '435px',
                mr: 0,
                position: 'relative',
              },
            }}
          >
            <Box
              sx={{
                height: '100%',
                '@media only screen and (min-width: 1170px)': {
                  height: '613px',
                  left: '0px',
                  position: 'absolute',
                  right: 'auto',
                  top: '50%',
                  transform: 'translateY(-50%) translateY(-24px)',
                  width: '770px',
                },
              }}
            >
              <GatsbyImage
                image={image.gatsbyImageData}
                alt={image.description}
                style={{
                  height: '100%',
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default FullBleedImageCalloutSection
